import { useEffect, useRef } from "react";

const RT_STYLE_ID = "rt-styles";
const RT_CSS = `
  .rt-mobile table { width: 100%; }
  @media (max-width: 576px) {
    .rt-mobile table,
    .rt-mobile thead,
    .rt-mobile tbody,
    .rt-mobile th,
    .rt-mobile td,
    .rt-mobile tr { display: block; }

    .rt-mobile thead { display: none; }

    .rt-mobile tr {
      margin-bottom: 12px;
      border: 1px solid #eee;
      border-radius: 8px;
      padding: 8px;
      background: #fff;
    }

    .rt-mobile td {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      gap: 12px;
      padding: 8px 12px !important;
      border: 0 !important;
      border-bottom: 1px solid #f1f1f1 !important;
      word-break: break-word;
    }

    .rt-mobile td:last-child { border-bottom: 0 !important; }

    .rt-mobile td::before {
      content: attr(data-label);
      font-weight: 600;
      color: #334155;
      flex: 0 0 45%;
      max-width: 45%;
    }
  }
`;

function injectStylesOnce() {
  if (typeof document === "undefined") return;
  if (document.getElementById(RT_STYLE_ID)) return;
  const style = document.createElement("style");
  style.id = RT_STYLE_ID;
  style.innerHTML = RT_CSS;
  document.head.appendChild(style);
}

/** Lee los TH del thead y los usa como data-label en los TD (si no lo tienen) */
function applyDataLabels(tableEl) {
  if (!tableEl) return;
  const headers = Array.from(tableEl.querySelectorAll("thead th")).map((th) =>
    (th.textContent || "").trim()
  );
  const rows = tableEl.querySelectorAll("tbody tr");
  rows.forEach((row) => {
    Array.from(row.children).forEach((cell, idx) => {
      if (cell.tagName.toLowerCase() !== "td") return;
      if (!cell.hasAttribute("data-label")) {
        const label = headers[idx] || "";
        if (label) cell.setAttribute("data-label", label);
      }
    });
  });
}

export default function useResponsiveTable(deps = []) {
  const tableRef = useRef(null);

  useEffect(() => {
    injectStylesOnce();
    applyDataLabels(tableRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps); // pasa aquí "data" u otro array que re-renderice filas

  return { tableRef, containerClass: "rt-mobile" };
}